import { render } from "./CategoryManagementView.vue?vue&type=template&id=12cf04a6&scoped=true&ts=true"
import script from "./CategoryManagementView.vue?vue&type=script&lang=ts"
export * from "./CategoryManagementView.vue?vue&type=script&lang=ts"

import "./CategoryManagementView.vue?vue&type=style&index=0&id=12cf04a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cf04a6"]])

export default __exports__